import React from "react"
import EnquiryManagement from "../../components/admin/EnquiryManagement"

const Enquiries: React.FC = () => {
  return <EnquiryManagement />
}

export default Enquiries
